<template>
  <path pid="0" d="M19.976 11.974h-5.873V6.327c0-.52-.438-.941-.979-.941h-.107c-.499.053-.875.46-.872.941v5.647H6.272c-.54 0-.978.421-.978.941v.104c.055.479.477.84.978.837h5.873v5.648c0 .52.439.94.98.94h.117c.494-.057.865-.462.861-.94v-5.648h5.873c.54 0 .979-.42.979-.94v-.114c-.06-.475-.481-.831-.979-.828z"/>
</template>
